import { useAuthContext } from '../../../contexts/authContext';
import { ModulesSideBar } from '../../components/navbar/components';
import { ILayout } from '../../../shared/types/layout';
import NavBar from '../../components/navbar/navbar';
import { Box } from '@mui/material';

export function LayoutDefault({ children }: ILayout) {
    const { tokenAuth } = useAuthContext();
    return (
        <Box sx={{ flexGrow: 1, display: 'block' }}>
            {tokenAuth && <NavBar modules={ModulesSideBar} />}

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    mt: tokenAuth && 10,
                    ml: tokenAuth && 10,
                    color: 'primary.main',
                }}
            >
                {children}
            </Box>
        </Box>
    );
}
